import * as Yup from 'yup';
import commonValidateMethodPer from '../validateCommonMethod';
export const validateDateOfPaymentPer006 = Yup.string()
  .nullable()
  .checkDateOfPaymentPer006();
